import State, { getActivityForDay } from './state'
import slides from './slides'
import activity from './activity'
import audioManager from '@/scripts/audio/audioManager'
import analytics, { ACTION_ACTIVITY_VIEW } from '@/scripts/analytics'
import { isArchive } from '@/scripts/config/settings'

async function init(root: HTMLElement): Promise<void> {
  const container = State.refs.emblaContainer!
  slides.buildSlides(container)

  const { default: EmblaCarousel } = await import('embla-carousel')
  const emblaRoot = root.querySelector('.embla') as HTMLElement

  State.embla = EmblaCarousel(emblaRoot, {
    loop: true,
    align: 'center',
    duration: 20,
    dragFree: false,
  }) as typeof State.embla extends null ? never : NonNullable<typeof State.embla>

  await initStartingSlide()
  initNavigationButtons()
  initSlideSelectHandler()
}

async function initStartingSlide() {
  if (!State.embla) return
  const startIndex = State.day - 1
  State.embla.scrollTo(startIndex, true)

  const idx = State.embla.selectedScrollSnap()
  if (idx === undefined) return
  await slides.ensureSlideLoaded(idx)
  slides.warmNeighborsAround(idx)

  const act = getActivityForDay(State.day)
  if (act?.linkHash) {
    analytics.sendCustomEvent(ACTION_ACTIVITY_VIEW, act.linkHash)
  }
}

function initNavigationButtons() {
  const prevBtn = State.refs.btnPrev!
  const nextBtn = State.refs.btnNext!

  prevBtn.onclick = () => handleNavClick('prev')
  nextBtn.onclick = () => handleNavClick('next')
}

function handleNavClick(direction: 'prev' | 'next') {
  if (!State.embla) return
  State.phase = 1

  if (direction === 'prev') {
    State.embla.scrollPrev()
  } else {
    State.embla.scrollNext()
  }
}

function initSlideSelectHandler() {
  if (!State.embla) return
  State.embla.on('select', async () => {
    if (!State.embla) return
    audioManager.stopItemSfx(500)

    const idx = State.embla.selectedScrollSnap()
    if (idx === undefined) return
    State.day = idx + 1

    if (!isArchive) {
      trackActivityView(State.day)
      activity.setButtonContent(State.day)
    }
    resetPhaseForSlide(idx)

    await slides.ensureSlideLoaded(idx)
    slides.warmNeighborsAround(idx)
  })
}

function trackActivityView(day: number) {
  const act = getActivityForDay(day)
  if (act?.linkHash) {
    analytics.sendCustomEvent(ACTION_ACTIVITY_VIEW, act.linkHash)
  }
}

function resetPhaseForSlide(idx: number) {
  const slide = slides.Slides[idx]
  if (!slide) return

  slide.itemP1.classList.remove('invisible')
  slide.itemP2.classList.add('invisible')
  State.phase = 1
}

async function scrollToDay(day: number) {
  if (!State.embla) return

  const targetIndex = day - 1
  State.embla.scrollTo(targetIndex, true)

  const idx = State.embla.selectedScrollSnap()
  if (idx === undefined) return
  State.day = idx + 1

  await slides.ensureSlideLoaded(idx)
  slides.warmNeighborsAround(idx)
  resetPhaseForSlide(idx)
  if (!isArchive) {
    activity.setButtonContent(State.day)
    trackActivityView(State.day)
  }
}

export default { init, scrollToDay }
